import { render, staticRenderFns } from "./BookResult.vue?vue&type=template&id=5fc99a4b&scoped=true&"
import script from "./BookResult.vue?vue&type=script&lang=js&"
export * from "./BookResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc99a4b",
  null
  
)

export default component.exports